export default __webpack_public_path__ + "static/media/Roboto-Italic.dcb583d9.ttf";